import useDebounce from "@/hooks/utils/useDebounce";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useState } from "react";

const useSearchBlogs = () => {
  const [search, setSearch] = useState("");
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const searchValueOnQuery = searchParams.get("search");

  const debouncedSearch = useDebounce(search);

  useEffect(() => {
    if (searchValueOnQuery && !search) {
      setSearch(searchValueOnQuery);
    }
  }, []);

  useEffect(() => {
    const params = new URLSearchParams(searchParams);
    if (debouncedSearch) {
      params.set("search", debouncedSearch);
      router.push(`${pathname}?${params.toString()}`);
    } else {
      params.delete("search");
      router.push(`${pathname}?${params.toString()}`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedSearch, pathname]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  return { handleChange, search };
};

export default useSearchBlogs;
